<template>
  <v-app-bar density="compact">
    <v-app-bar-nav-icon density="comfortable" color="secondary" @click="model = !model" />
    <v-toolbar-title class="pl-0">
      <slot name="title" />
    </v-toolbar-title>
    <v-spacer />
    <headbar-downloads-menu />
    <headbar-account-menu />
  </v-app-bar>
</template>

<script lang="ts" setup>
const model = defineModel<boolean>({ required: true })
</script>
